module.exports = __webpack_public_path__ + "static/media/calender.2d25ceac.svg";